import { render, staticRenderFns } from "./ReceiptLogDetail.vue?vue&type=template&id=281c6de8"
import script from "./ReceiptLogDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports